// Classes compartilhadas pelas etapas do checkout (visual "Checkout v3").
export const TITULO =
  'm-0 text-[13px] lg:text-lg font-extrabold uppercase tracking-[.01em] text-[#0f1729]';
export const LABEL =
  'text-[10px] font-bold uppercase tracking-[.04em] text-[#8a94a8]';
export const INPUT =
  'w-full min-h-11 rounded-xl border border-[#eef0f4] bg-[#f6f8fb] px-4 py-3 text-sm font-medium text-[#0f1729] placeholder:text-[#b6bdcb] focus:outline-none focus:border-[#ff2368]';
export const ERRO = 'text-[10px] font-bold text-red-500';
export const CTA =
  'w-full min-h-12 rounded-full bg-[#ff2368] px-4 text-xs font-extrabold uppercase tracking-[.12em] text-white shadow-[0_10px_24px_rgba(255,35,104,.25)] transition-colors hover:bg-[#e5195b] disabled:cursor-not-allowed disabled:opacity-45 disabled:hover:bg-[#ff2368] cursor-pointer';
// Opção selecionável (plano, horário, forma de pagamento): o contorno é
// desenhado com box-shadow interno para não mudar o tamanho ao selecionar.
export const ANEL_OFF = 'inset 0 0 0 1px #eef0f4';
